import { LinkedInCallback } from 'react-linkedin-login-oauth2';
export default function LinkedInPage() {
    return <LinkedInCallback />;
}
